import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { alertActions } from '../redux/actions/AlertsActions'
import Alert from '@mui/material/Alert/Alert'

let displayed = []

const Notifier = () => {
	const dispatch = useDispatch()
	const notifications = useSelector((store) => store.alerts.notifications || [])
	const { enqueueSnackbar, closeSnackbar } = useSnackbar()

	const storeDisplayed = (id) => {
		displayed = [...displayed, id]
	}

	const removeDisplayed = (id) => {
		displayed = [...displayed.filter((key) => id !== key)]
	}

	React.useEffect(() => {
		notifications.forEach(({ key, message, options = {}, dismissed = false }) => {
			if (dismissed) {
				// dismiss snackbar using notistack
				closeSnackbar(key)
				return
			}

			// do nothing if snackbar is already displayed
			if (displayed.includes(key)) return

			// options.persist = true // odkomentuj pri develope aby ti nemmizol
			// display snackbar using notistack
			enqueueSnackbar(message, {
				key,
				...options,
				onClose: (event, reason, myKey) => {
					if (options.onClose) {
						options.onClose(event, reason, myKey)
					}
				},
				onExited: (event, myKey) => {
					// removen this snackbar from redux store
					dispatch(alertActions.removeSnackbar(myKey))
					removeDisplayed(myKey)
				},
				content: () => {
					// destructure the options we need from the extended options
					// object, and provide a default case if we didn't provide any
					const { variant } = options || { variant: undefined }
					return <Alert severity={variant || 'info'} children={message} />
				}
			})

			// keep track of snackbars that we've displayed
			storeDisplayed(key)
		})
	}, [notifications, closeSnackbar, enqueueSnackbar, dispatch])

	return null
}

export default Notifier
